var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJobs = function SvgJobs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,11.7c0.3-0.3,0.3-0.9,0-1.2c-0.3-0.3-0.9-0.3-1.2,0c-0.3,0.3-0.3,0.9,0,1.2 C10.7,12.1,11.3,12.1,11.6,11.7z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,7.8c-0.8-0.8-1.9-1.2-3-1.2H6.3c-1.1,0-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v4.9c0,1.1,0.4,2.2,1.2,3 c0.8,0.8,1.9,1.2,3,1.2h9.3c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-4.9C19.9,9.6,19.4,8.5,18.7,7.8z M15.7,18.3H6.3 c-0.7,0-1.4-0.3-1.9-0.8c-0.5-0.5-0.8-1.2-0.8-1.9v-4.9C3.7,10,4,9.4,4.5,8.9s1.2-0.8,1.9-0.8h9.3c0.7,0,1.4,0.3,1.9,0.8 c0.5,0.5,0.8,1.2,0.8,1.9v4.9c0,0.7-0.3,1.4-0.8,1.9C17,18.1,16.4,18.3,15.7,18.3z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2,10.9C15,11,15,11.2,15,11.4c0,0.6-0.2,1.2-0.7,1.6c-0.4,0.4-1,0.7-1.6,0.7H9.3c-0.6,0-1.2-0.2-1.6-0.7 C7.3,12.6,7,12,7,11.4C7,11.2,7,11,6.8,10.9c-0.3-0.3-0.8-0.3-1.1,0c-0.1,0.1-0.2,0.3-0.2,0.6c0,1,0.4,2,1.1,2.7 c0.7,0.7,1.7,1.1,2.7,1.1h3.4c1,0,2-0.4,2.7-1.1c0.7-0.7,1.1-1.7,1.1-2.7c0-0.2-0.1-0.4-0.2-0.6C16,10.6,15.5,10.6,15.2,10.9z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,5.1C9.1,5,9.2,4.8,9.2,4.6c0-0.2,0.1-0.5,0.3-0.6c0.2-0.2,0.4-0.3,0.6-0.3h1.8c0.2,0,0.5,0.1,0.6,0.3 c0.2,0.2,0.3,0.4,0.3,0.6c0,0.2,0.1,0.4,0.2,0.6c0.1,0.1,0.3,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.6 c0-0.7-0.3-1.3-0.7-1.7c-0.5-0.5-1.1-0.7-1.7-0.7h-1.8c-0.7,0-1.3,0.3-1.7,0.7C7.9,3.3,7.6,3.9,7.6,4.6c0,0.2,0.1,0.4,0.2,0.6 C8.2,5.4,8.7,5.4,9,5.1z",
    fill: "currentColor"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jobs.a58eefaf.svg";
export { ForwardRef as ReactComponent };